import React, {useEffect, useState} from "react";
import {
    Box,
    TablePagination,
    Typography,
    useTheme,
    Card,
    CardContent
} from "@mui/material";
import Loader from "../../Common/Loader";
import {apiList} from "../../Common/Api/ApiList";
import AxiosInstance from "../../Common/Api/ApiHelper";
import ErrorToaster from "../../Component/ErrorToaster";
import {DataGrid} from "@mui/x-data-grid";
import searchicon from "../../Assets/image/dash/Minimalistic Magnifer.png";
import moment from "moment/moment";
import DateLogo from "../../Assets/image/dash/Calendar Search.png";
import ResponsiveDatePickers from "../BookingScreen/DateComponent";
import ActivityCharts from "../Activity/ActivityCharts";

const PAGE_SIZE_OPTIONS = [30];

const ActivityLogsScreen = () => {
    const [page, setPage] = useState(0);
    const [data, setData] = useState([]);
    const [dataChart, setDataChart] = useState({
        trend:      [],
        users:      [],
        categories: [],
    });
    const [totalData, setTotalData] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [rowsPerPage, setRowsPerPage] = useState(PAGE_SIZE_OPTIONS[0]);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    const [searchTerm, setSearchTerm] = useState("");

    const StartDateMoment = startDate && moment(startDate?.$d, "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)");
    const EndDateMoment = endDate && moment(endDate?.$d, "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ (z)");
    const dateDifference = EndDateMoment && EndDateMoment.diff(StartDateMoment, "days");

    const fetchLogsData = async (
        page = 0,
        pageSize = PAGE_SIZE_OPTIONS[0],
        search = ""
    ) => {
        try {
            let newPage = page * pageSize;

            const fromDate = startDate ? moment(startDate.$d).format("YYYY-MM-DD") : "";
            const toDate = endDate ? moment(endDate.$d).format("YYYY-MM-DD") : "";

            const response = await AxiosInstance.get(
                `${apiList.ActivityLogsList}?count=${newPage}&search=${search}&fromDate=${fromDate}&toDate=${toDate}`
            );

            const formatedData = response?.data?.r?.data?.map((x, i) => ({
                ...x,
                rowid: page * rowsPerPage + i + 1,
            }));

            setDataChart({
                trend:      response?.data?.r?.trend          ?? [],
                users:      response?.data?.r?.top_users      ?? [],
                categories: response?.data?.r?.top_categories ?? [],
            });

            if (formatedData?.length > 0) {
                setData(formatedData);
                setTotalData(response?.data?.r?.total_count ?? formatedData?.length);
            }else {
                if (newPage === 0) {
                    setData([]);
                }
                setTotalData(0);
            }
            setIsLoading(false);
        } catch (error) {
            ErrorToaster(error);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            setPage(0);
            fetchLogsData(0, rowsPerPage, searchTerm);
        }, 500);

        return () => clearTimeout(timer);
    }, [searchTerm, startDate, endDate]);



    const handlePageChange = (e, newPage) => {
        setPage(newPage);
        fetchLogsData(newPage, rowsPerPage, searchTerm);
    };
    const handleRowsPerPageChange = (event) => {
        const newSize = parseInt(event.target.value, 30);
        setRowsPerPage(newSize);
        setPage(0);
        fetchLogsData(0, newSize, searchTerm);
    };

    const theme = useTheme();
    const columns = [
        {
            headerClassName: "super-app-theme--header",
            field: "rowid",
            headerName: "Sr.",
            flex: 0.3,
            minWidth: 50,
            headerAlign: "center"
        },
        {
            headerClassName: "super-app-theme--header",
            field: "full_name",
            headerName: "User",
            flex: 0.3,
            minWidth: 150,
            headerAlign: "center"
        },
        {
            headerClassName: "super-app-theme--header",
            field: "activity_label",
            headerName: "Activity",
            flex: 0.3,
            minWidth: 250,
            headerAlign: "center"
        },
        {
            headerClassName: "super-app-theme--header",
            field: "description",
            headerName: "Description",
            flex: 1.5,
            minWidth: 250,
            headerAlign: "center"
        },
        {
            headerClassName: "super-app-theme--header",
            field: "created_at",
            headerName: "Date",
            width: 200,
            headerAlign: "center",
            renderCell: (cell) => {
                return (
                    <span>{`${moment
                        .utc(cell?.row?.created_at)
                        .local()
                        .format("ll LTS")}`}</span>
                );
            },
        },
    ];

    return (
        <>
            <Box
                sx={{
                    width: "100%",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        pb: 0,
                    }}
                >
                    <Typography
                        variant="h6"
                        noWrap
                        component="div"
                        sx={{fontSize: "28px"}}
                    >
                        Analytics
                    </Typography>
                </Box>

                <Box
                    sx={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        flexDirection: {xs: "column", md: "row"},
                        gap: "1rem",
                        alignItems: {xs: "stretch", md: "end"},
                        justifyContent: "space-between",
                    }}
                >
                    <Box
                        sx={{
                            width: {xs: "100%", sm: "100%", md: "350px"},
                            height: "45px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            position: "relative",
                        }}
                    >
                        <input
                            type="text"
                            placeholder="Search for user, activity, description"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            style={{
                                width: "100%",
                                height: "45px",
                                borderRadius: "10px",
                                fontSize: "14px",
                                boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                                border: "none",
                                outline: "none",
                                paddingLeft: "20px",
                            }}
                        />
                        <span
                            style={{
                                position: "absolute",
                                right: "15px",
                                top: "10px",
                            }}
                        >
                    <img src={searchicon} alt="Search"/>
                  </span>
                    </Box>

                    <Box
                        sx={{
                            padding: "8px",
                            width: {xs: "100%", sm: "100%", md: "300px"},
                            borderRadius: "8px",
                            fontSize: "14px",
                            boxShadow: "0 3px 10px 0 rgba(0, 0, 0, 0.1)",
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: "0.5rem",
                                pb: "0.15rem",
                                color: theme.palette.text.primary,
                            }}
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "start",
                                    gap: "0.5rem",
                                }}
                            >
                                <img src={DateLogo} height={17} width={17} alt="" srcSet=""/>
                                Date
                            </Box>
                            <Box
                                onClick={() => {
                                    setStartDate(null);
                                    setEndDate(null);
                                }}
                                sx={{
                                    cursor: "pointer",
                                    color: "#3498db",
                                    display: dateDifference !== null ? "block" : "none",
                                    "&:hover": {fontWeight: "500"},
                                }}
                            >
                                Clear
                            </Box>
                        </Box>
                        <ResponsiveDatePickers
                            endDate={endDate}
                            setEndDate={setEndDate}
                            startDate={startDate}
                            setStartDate={setStartDate}
                            disableFutureDates={true}
                        />
                    </Box>
                </Box>

                <Card style={{marginTop: "10px"}}>
                    <CardContent>
                        {isLoading ? (
                            <Loader/>
                        ) : (
                            <>
                                <ActivityCharts
                                    trendData={dataChart.trend}
                                    userData={dataChart.users}
                                    categoryData={dataChart.categories}
                                />

                                <Box sx={{width: "100%", overflowX: "auto"}}>
                                    <Typography
                                        variant="h6"
                                        noWrap
                                        component="div"
                                        sx={{fontSize: "28px"}}
                                    >
                                        Logs
                                    </Typography>
                                    <Box sx={{minWidth: 600}}>
                                        <DataGrid
                                            rows={data}
                                            columns={columns}
                                            disableColumnMenu
                                            disableColumnSorting
                                            hideFooter
                                            disableColumnFilter
                                            disableAutosize
                                            disableColumnResize
                                            getRowId={(row) => row.id}
                                            sx={{
                                                ".MuiDataGrid-cell": {textAlign: "center"},
                                                ".MuiDataGrid-columnHeaderTitle": {fontWeight: "600", color: "white"},
                                                "& .super-app-theme--header": {background: theme.palette.primary.Blend},
                                            }}
                                        />
                                    </Box>
                                </Box>
                                <TablePagination
                                    component="div"
                                    count={totalData}
                                    page={page}
                                    onPageChange={handlePageChange}
                                    rowsPerPage={rowsPerPage}
                                    onRowsPerPageChange={handleRowsPerPageChange}
                                    rowsPerPageOptions={PAGE_SIZE_OPTIONS}
                                />
                            </>
                        )}
                    </CardContent>
                </Card>
            </Box>
        </>
    )
}

export default ActivityLogsScreen;